import type { ForfeitAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { YinshState } from "../types/game-state";

/**
 * A player can forfeit at any time while the game is still active. The
 * forfeiting player must be one of the players in the game, and the game
 * must not already be over.
 */
export function validateForfeit(
  state: YinshState,
  action: ForfeitAction,
): ValidationResult {
  if (state.phase === "GAME_END") {
    return { valid: false, error: "Game is already over" };
  }
  const player = state.players.find((p) => p.color === action.player);
  if (!player) {
    return { valid: false, error: "Player is not part of this game" };
  }
  return { valid: true };
}
